import type { ActivityComponentType } from '@stackflow/react';
import { ChatPage } from '@/features/messaging';

type ChatParams = { conversationId: string; scrollToMessageId?: string };

const ChatActivity: ActivityComponentType<ChatParams> = ({ params }) => {
  return <ChatPage conversationId={params.conversationId} scrollToMessageId={params.scrollToMessageId} />;
};

export default ChatActivity;
